import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { colors } from 'design-system';

// eslint-disable-next-line import/prefer-default-export
export const cameraStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      padding: '0px !important',
    },
    aviseVin: {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid #0193E5`,
      borderRadius: 10,
      padding: theme.spacing(2),
      gap: theme.spacing(1),
      justifyContent: 'space-between',
      backgroundColor: '#F5FAFF',
    },
    aviseVinContent: {
      display: 'flex',
      alignItems: 'baseline',
      gap: theme.spacing(1),
      fontWeight: 500,
    },
    aviseVinIcon: {
      color: '#0193E5',
    },
    aviseVinText: {
      maxWidth: '190px',
      fontSize: '15px',
    },
    aviseVinButton: {
      color: '#0193E5',
      fontWeight: 'bold',
      cursor: 'pointer',
    },
    gridWrapper: {
      padding: theme.spacing(1),
    },
    cameraCallToAction: {
      position: 'absolute',
      left: 137,
      top: -50,
      borderRadius: 8,
      backgroundColor: colors.madison,
      color: colors.white,
      fontSize: 14,
      lineHeight: '16px',
      fontFamily: 'Arial',
      fontWeight: 'normal',
      textAlign: 'center',
      padding: 6,
      width: 101,
      height: 63,
      transform: 'translateY(-33px)',
    },
    cameraCallToActionArrow: {
      width: 0,
      height: 0,
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderRight: `12px solid ${colors.madison}`,
      position: 'absolute',
      left: -10,
      top: 16,
    },
    imageWrapper: {
      width: '100%',
      height: 300,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      overflow: 'hidden',
      borderRadius: 10,
    },
    nextButton: {
      paddingTop: '24px',
      paddingBottom: '24px',
    },
  }),
);
